<template>
    <div>
        <transition name="slide-fade">
            <div class="modal" atm="serial-modal" data-cy="modal_serial" :class="{'open' : open}" v-if="open">
                <div class="modal-content">
                    <div class="bg-white w-full rounded-sm" v-if="serialModel != null">
                        <div class="mt-10">
                            <SerialDetail
                                :serialModel="serialModel"
                                @clickDetail="clickDetail($event)">
                            </SerialDetail>
                            <div class="relative">
                                <Serial
                                    :serialModel="serialModel"
                                    :isStaff="isStaff"
                                    :isUsed="isUsed"
                                    ref="serial">
                                </Serial>
                                <div class="absolute bottom-0 left-0 right-0">
                                    <SerialTimer
                                            :serialModel="serialModel"
                                            :isStaff="isStaff"
                                            @onSerialExpired="onSerialExpired()">
                                    </SerialTimer>
                                    <img v-if="!privilegeMsg" class="mx-auto pb-4" src="@/assets/logo-bzbs.svg">
                                </div>
                            </div>
                            <div class="bg-a-blue-f2f5ff mt-0.5" v-if="privilegeMsg">
                                <PrivilegeMessage :forStaff="privilegeMsg" :serialModel="serialModel" @clickStaff="clickForStaff($event)"></PrivilegeMessage>
                                <img class="mx-auto py-4" src="@/assets/logo-bzbs.svg">
                            </div>
                            <div class="text-center text-18 pt-4">
                                <div class="px-5 pb-4" v-if="isShowBtnCoupon">
                                    <button class="bg-a-blue-2140a6 text-a-white-ffffff rounded-sm px-4 btn w-full font-bold" data-cy="btn_serial_coupon" @click="clickMyCoupon()">
                                        {{lbl.serial.btn_coupon}}
                                    </button>
                                </div>
                                <div class="px-5 pb-5">
                                    <button class="bg-a-white-ffffff border border-a-blue-2140a6 text-a-blue-2140a6 rounded-sm px-4 btn w-full  font-bold" data-cy="btn_serial_close" @click="clickClose()">
                                        {{lbl.serial.btn_close}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div class="modal-backdrop" v-if="open"></div>
        </transition>
    </div>
    
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import SerialDetail from "./component/SerialDetail.vue";
import Serial from "./component/Serial.vue";
import PrivilegeMessage from "./component/PrivilegeMessage.vue";
import SerialTimer from "./component/SerialTimer.vue";

export default {
    name: "SerialModal",
    mixins: [LocaleMixin],
    components: {
        SerialDetail,
        Serial,
        PrivilegeMessage,
        SerialTimer,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            serialModel: null,
            privilegeMsg: false,
            isStaff: false,
            isShowStaff: true,
            isUsed: false,
            isShowBtnCoupon: true,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.serialModel = config.serialModel;
            this.isStaff = config.isStaff;
            this.isShowStaff = config.isShowStaff;
            this.isUsed = config.isUsed;

            if (this.$route.name == 'history-coupon') {
                this.isShowBtnCoupon = false;
            } else {
                this.isShowBtnCoupon = true;
            }

            console.log('this.serialModel', this.serialModel)
            this.tracking.screenName('campaign_serail');
            this.tracking.event('campaign_serail', 'campaign_serail', this.serialModel.campaignId, null);
            console.log('this.serialModel', this.serialModel)
            document.body.classList.add('not-scroll');
            this.open = true;
            this.checkPrivilegeMessage();
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function() {
            this.tracking.event('campaign_serail_closed', 'click_closed', null, null);
            this.hide();
            this.controller.sendCloseModal();
        },
        clickMyCoupon: function() {
            this.hide();
            this.controller.sendCouponModal();
        },
        clickDetail: function(detail) {
            this.tracking.event('campaign_serail_detail', 'click_detail', this.serialModel.campaignId, null);
            this.hide();
            this.controller.sendClickDetail(detail);
        },
        clickForStaff: function() {
            this.tracking.event('campaign_mark_use', 'click_mark_use', this.serialModel.campaignId, null);
            this.controller.sendClickForStaff({redeemKey: this.serialModel.redeemKey});
            this.isStaff = true;
        },

        getRedeemMessage: function () {
            let dateStr = DatetimeHelper.getDatetimeFullFormat(this.serialModel.redeemTimestamp);
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },
        checkPrivilegeMessage: function() {
            if (this.serialModel.privilegeMessage.toLowerCase() == "mark use" && this.isShowStaff == true) {
                this.privilegeMsg = true;
            } else {
                this.privilegeMsg = false;
            }
        },

        onSerialExpired: function() {
            this.$refs['serial'].setSerialExpire();
            this.controller.sendSerialExpire();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            // overflow: unset;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }
    .btn {
        height: 50px;
    }
</style>
